export default "__VITE_ASSET__D_ueXkwj__"